<p-dialog header="Refunds" [(visible)]="showDialog" [modal]="true" [blockScroll]="false" (onHide)="cancel()" [style]="{width: '500px'}">
  <div class="bold">
    {{workOrder.serviceType}}: {{workOrder.number}}
  </div>
  <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
  @for (charge of charges; track charge; let i = $index) {
    <div class="container">
      <div class="bold header-line">Charge {{i + 1}}</div><br/>
      <div>Date: {{charge.created | date: 'shortDate'}}</div>
      <div>Amount: {{charge.chargeAmount | currency: 'USD' : 'symbol'}} </div>
      <!-- @if (!charge.refunded) {
        <div class="regular-link" (click)="refund(charge, false)">
          [Refund]
        </div>
      } -->
      @if (!charge.refunded) {
        <div class="regular-link" (click)="refund(charge, true)">
          [Refund]
        </div>
      }
      @if (charge.refunded) {
        <div>Amount Refunded: {{charge.amountRefunded | currency: 'USD' : 'symbol'}}</div>
      }
    </div>
  }
  <div class="footer">
    <p-button type="button" (click)="cancel()" label="Cancel" severity="info"></p-button>
  </div>
</p-dialog>